import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { useEffect } from "react";
import { useGetElementDetailsQuery } from "services/api/warehouseApi";
import { setElementDetails } from "store/Slices/elementDetailsSlice";
import { useAppDispatch } from "./StoreHooks";

export function useElementDetails(storeNb: number, elementId: string) {
  const dispatch = useAppDispatch();

  const {
    data,
    isLoading,
    isFetching,
    error: queryError,
  } = useGetElementDetailsQuery(
    { storeNb, elementId },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (data) {
      dispatch(setElementDetails(data));
    }
  }, [data, dispatch]);

  return {
    detailsInfos: data,
    isLoading: isLoading || isFetching,
    error: queryError ? (queryError as FetchBaseQueryError) : undefined,
  };
}
